import type * as ecModels from '../../../models'

import type * as models from './models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State<
  TTypeParams extends ecModels.TypeParams = ecModels.TypeParams,
> {
  /**
   * Tracks the statuses of requested entities
   *
   * @see {@link models.StatusLookup}
   */
  statuses: models.StatusLookup
}
export namespace State {
  export const INITIAL: State = {
    statuses: {},
  }
}
